import { Component, ChangeDetectionStrategy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { roundTo } from "round-to";
import { PrintLayoutService } from "src/app/components/print-layout/print-layout.service";
import { User } from "src/app/core/models/user.model";
import { CustomerType } from "src/app/models/customer";
import { Invoice } from "src/app/models/invoice";
import { Payment, PaymentMode } from "src/app/models/payment";
import { Tax } from "src/app/models/tax";
import { fadeInOut } from "src/app/services/animations";
import { EntityDataSourceCustomBindReport } from "src/app/services/entity.datasource";
import { SalesLineService } from "src/app/services/salesLine.service";

@Component({
  selector: "app-print-mvr-invoice",
  templateUrl: "./print-mvr-invoice.component.html",
  styleUrls: ["./print-mvr-invoice.component.scss"],
  animations: [fadeInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintMvrInvoiceComponent implements OnInit {
  displayedColumnsSOLine: string[] = [
    "itemCode",
    "description",
    "uom",
    "rate",
    "qty",
    "promotion",
    "amount",
  ];

  id: number;
  invoice: Invoice;
  tax: Tax;
  screenName: string;
  logedUser: User;

  dataSourceSOLine: any[] = [];
  dataSource: EntityDataSourceCustomBindReport;
  readonly endpointUrl = "/api/salesLines/GetSalesLineView";
  lineCount: number;
  payment: Payment;

  constructor(
    private printLayoutService: PrintLayoutService,
    private salesLineService: SalesLineService,
    private route: ActivatedRoute
  ) {
    this.id = Number(this.route.snapshot.paramMap.get("id"));

    this.route.data.subscribe(({ invoice }) => {
      if (invoice) {
        this.invoice = invoice;

        console.log(this.invoice);

        this.invoice.paymentInvoiceMaps.forEach((x) => {
          this.payment = x.payment;
        });
      }
    });

    this.route.data.subscribe(({ tax }) => {
      if (tax) {
        this.tax = tax;
      }
    });
  }

  ngOnInit() {
    this.dataSource = new EntityDataSourceCustomBindReport(
      this.salesLineService,
      this.endpointUrl
    );

    this.dataSource.loadReport(
      this.invoice.salesId,
      this.displayedColumnsSOLine
    );
    this.dataSource.entityCount$.subscribe((c) => (this.lineCount = c));
    this.dataSource.currentData$.subscribe((rows) => {
      this.dataSourceSOLine = rows;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.printLayoutService.onDataReady();
    }, 1000);
  }

  getCustomerType(value: number) {
    return CustomerType[value];
  }
  getPaymentMode(value: number) {
    return PaymentMode[value];
  }
}
